/* eslint-disable ember/no-computed-properties-in-native-classes, ember/no-get, no-restricted-properties */
import Controller from '@ember/controller';
import { action, computed, get } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class TopicsController extends Controller {
  @service
  features;

  @service
  strings;

  @alias('features.sidekickEnabled')
  sidekickEnabled;

  @tracked
  tab = 'current';

  @action
  setTab(value) {
    this.tab = value;
  }

  @computed('model.states.@each.awarded')
  get currentAndRecentTopics() {
    let grouped = {
      Current: [],
      Recent: [],
    };

    const statesBySubject = this.model.states;

    if (statesBySubject) {
      // Flatten states from all subjects
      let allStates = statesBySubject.reduce((acc, subjectStates) => {
        const subjectStatesArray = subjectStates.toArray
          ? subjectStates.toArray()
          : subjectStates;
        return acc.concat(subjectStatesArray);
      }, []);

      // Group states by goal object
      let statesByGoal = allStates.reduce((acc, state) => {
        const goal = get(state, 'goal');
        const goalId = get(state, 'goal_id');
        const awarded = get(state, 'awarded');
        if (!acc[goalId]) {
          acc[goalId] = {
            goal, // Directly use the related goal from the server
            awardedStates: [],
          };
        }

        acc[goalId].awardedStates.push(awarded);
        return acc;
      }, {});

      // Filter and group only if all states are awarded 2 or 3
      Object.values(statesByGoal).forEach(({ goal, awardedStates }) => {
        if (awardedStates.every((value) => value === 2)) {
          grouped['Current'].push({ goal });
        } else if (awardedStates.every((value) => value === 3)) {
          grouped['Recent'].push({ goal });
        }
      });
    }

    return grouped;
  }
}
